module.exports = __webpack_public_path__ + "static/media/bedroom.a961b044.svg";